const CALL_DISABLED_STATUSES = ["Done", "SupportCanceled", "DriverCanceled", "CustomerCanceled"];

/**
 * Mirrors legacy `components/Call-btn` exactly: calling the driver is
 * disabled once the order is finished or canceled by any party, regardless
 * of order kind. Takes the raw status code as a plain `string`, matching
 * how `OrderStatusInfo.code` is already modeled (`domain/order.types.ts`).
 */
export function isCallDisabled(statusCode: string): boolean {
  return CALL_DISABLED_STATUSES.includes(statusCode);
}
